module.exports = "https://www.gc-pro.gnp.com.mx/ff4e7508fa2de46f68dc12fb9352124b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_phone.png
// module id = 1843
// module chunks = 0